import BaseMessage from '../BaseMessage';
const major = 2;
const minor = 1;
const revision = 0;
let agent = null;

const setAgentName = name => {
  agent = name;
};

class Connect extends BaseMessage {
  constructor(authentication, sessionid) {
    super();
    this.method = 'blade.connect';
    const params = {
      version: {
        major,
        minor,
        revision
      },
      authentication: authentication
    };

    if (sessionid) {
      params.sessionid = sessionid;
    }

    if (agent) {
      params.agent = agent;
    }

    this.buildRequest({
      method: this.method,
      params
    });
  }

}

export { Connect, setAgentName };